<template>
  <div class="container mt-3 p-4 rounded">
    <h2 v-if="showButtons">Cosa vuoi fare?</h2>
    <div class="action-buttons" v-if="showButtons">
      <div class="col-set col-left">
        <h3 class="section-title">Dare ripezioni?</h3>
        <button class="btn btn-warning" v-if="currentUser.role !== 'tutor' || currentUser.role === 'developer'" @click="showTutorDisponibilitaSection">
          <font-awesome-icon :icon="['fas', 'calendar']" />&nbsp;Peer-tutoring: inserisco le disponibilità come tutor
        </button>
        <button class="btn btn-warning" @click="showLastMinuteTutorSection">
          <font-awesome-icon :icon="['fas', 'hourglass']" />&nbsp;Ripetizioni last minute: inserisco le disponibilità come tutor
        </button>
        <button class="btn btn-warning" v-if="currentUser.role === 'tutor' || currentUser.role === 'developer'" @click="showTutorDisponibilitaSection">
          <font-awesome-icon :icon="['fas', 'calendar-days']" />&nbsp;Inserisco le mie disponibilità come tutor
        </button>
        <button class="btn btn-warning" @click="showValutazioneSection">
          <font-awesome-icon :icon="['fas', 'bars']" />&nbsp;Inserisco le valutazioni
        </button>
      </div>

      <div class="col-set col-right">
        <h3 class="section-title">Prendere ripetizioni?</h3>
        <button class="btn btn-warning" v-if="currentUser.role !== 'tutor' || currentUser.role === 'developer'" @click="showStudentValutazioneSection">
          <font-awesome-icon :icon="['fas', 'handshake']" />&nbsp;Peer-tutoring: prenoto una ripetizione
        </button>
        <button class="btn btn-warning" v-if="currentUser.role !== 'tutor' || currentUser.role === 'developer'" @click="showLastMinuteStudentSection">
          <font-awesome-icon :icon="['fas', 'hourglass-half']" />&nbsp;Ripetizioni last minute: prenoto una ripetizione
        </button>
        <button class="btn btn-warning" v-if="currentUser.role !== 'tutor' || currentUser.role === 'developer'" @click="showStudentValutazioneSection">
          <font-awesome-icon :icon="['fas', 'graduation-cap']" />&nbsp;Prenoto una ripetizione con tutor certificati
        </button>
        <button class="btn btn-warning" @click="showProfileSection">
          <font-awesome-icon :icon="['fas', 'user']" />&nbsp;Profilo
        </button>
      </div>
    </div>

    <div v-else>
      <TutorDashboard v-if="sezione_disponibilita_tutor" :currentUser="currentUser" :activeTab="'sezione-disponibilita'" @change-section="showButtonsSection"/>
      <TutorDashboard v-if="materie_insegnabili_tutor" :currentUser="currentUser" :activeTab="'sezione-subject-availability'" @change-section="showButtonsSection"/>
      <TutorDashboard v-if="sezione_valutazione_tutor" :currentUser="currentUser" :activeTab="'sezione-prenotazioni'" @change-section="showButtonsSection"/>
      <StudentDashboard v-if="sezione_valutazione_studente" :currentUser="currentUser" :activeTab="'sezione-prenotazioni'" @change-section="showButtonsSection"/>
      <StudentDashboard v-if="last_minute_student" :currentUser="currentUser" :activeTab="'sezione-lastminute'" @change-section="showButtonsSection"/>
      <TutorDashboard v-if="showTutorProfile" :currentUser="currentUser" :activeTab="'sezione-profilo'" @change-section="showButtonsSection"/>
      <StudentDashboard v-if="showStudentProfile" :currentUser="currentUser" :activeTab="'sezione-profilo'" @change-section="showButtonsSection"/>
    </div>
  </div>
</template>

<script>
//import BuddyDashboard from "@/components/BuddyDashboard.vue";
import TutorDashboard from "@/components/TutorDashboard.vue";
//import AdminDashboard from "@/components/AdminDashboard.vue";
import StudentDashboard from "@/components/StudentDashboard.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faCalendar,
  faGraduationCap,
  faBars,
  faHandshake,
  faHourglass,
  faHourglassHalf,
  faCalendarDays
} from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faCalendar, faGraduationCap, faBars, faHandshake, faHourglass, faHourglassHalf, faCalendarDays);

export default {
  name: 'UserDashboard',
  components: {
    StudentDashboard,
    TutorDashboard,
    //BuddyDashboard,
    //AdminDashboard,
    FontAwesomeIcon
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      showButtons: true,
      sezione_disponibilita_tutor: false,
      sezione_valutazione_tutor: false,
      last_minute_student: false,
      sezione_valutazione_studente: false,
      materie_insegnabili_tutor: false,
      showTutorProfile: false,
      showStudentProfile: false
    };
  },
  methods: {
    showTutorDisponibilitaSection() {
      this.showButtons = false;
      this.sezione_disponibilita_tutor = true;
    },
    showValutazioneSection() {
      this.showButtons = false;
      this.currentUser.role === 'tutor' || this.currentUser.role === 'developer'  ? this.sezione_valutazione_tutor = true : this.sezione_valutazione_studente = true;
    },
    showLastMinuteStudentSection() {
      this.showButtons = false;
      this.last_minute_student = true;
    },
    showStudentValutazioneSection() {
      this.showButtons = false;
      this.sezione_valutazione_studente = true;
    },
    showLastMinuteTutorSection() {
      this.showButtons = false;
      this.materie_insegnabili_tutor = true;
    },
    showProfileSection() {
      this.showButtons = false;
      this.currentUser.role === 'tutor' || this.currentUser.role === 'developer' ? this.showTutorProfile = true : this.showStudentProfile = true;
    },
    showButtonsSection() {
      this.showButtons = true;
      this.sezione_disponibilita_tutor = false;
      this.sezione_valutazione_tutor = false;
      this.last_minute_student = false;
      this.sezione_valutazione_studente = false;
      this.materie_insegnabili_tutor = false;
      this.showTutorProfile = false;
      this.showStudentProfile = false;
    }
  },
}
</script>

<style scoped>
.container {
  caret-color: transparent;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  margin-top: 50px;
}

.col-set {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 48%;
}

.section-title {
  text-align: center;
  margin-bottom: 10px;
}

.action-buttons button {
  width: 100%;
  padding: 12px;
  color: black;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 30px;
  }

  .col-set {
    width: 100%;
  }

  .action-buttons button {
    width: 100%;
  }
}
</style>